import Button from '@/components/Shared/Form/Button';
import { ModalWrapper } from '@/components/Shared/ModalWrapper';
import { ContentType } from '@/constants/content.constants';
import { useAcceptTermsAndPrivacy } from '@/hooks/Request/mutation';
import { useGetAppContent } from '@/hooks/User/queries';
import { routes } from '@/utils/routes';
import { signOut } from 'next-auth/react';
import { useEffect, useState } from 'react';

// Revalidate terms and conditions every 10 minutes
// export const revalidate = 600;

// export const dynamicParams = true

interface Props {
  isOpen: boolean;
}
export function TermsAndConditions(props: Readonly<Props>) {
  const { data } = useGetAppContent(ContentType.TERMS_AND_CONDITIONS);
  const { mutate, isPending } = useAcceptTermsAndPrivacy();
  const [isOpen, setIsOpen] = useState(props.isOpen);

  const handleAccept = () => {
    mutate(undefined, {
      onSuccess: () => {
        setIsOpen(false);
        window.location.href = routes.dashboard;
      },
    });
  };

  const handleReject = async () => {
    await signOut();
    setIsOpen(false);
    window.location.href = routes.login;
  };

  useEffect(() => {
    if (props.isOpen) {
      setIsOpen(props.isOpen);
    }
  }, [props.isOpen]);

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Terms & Conditions"
      footer={
        <div className="flex space-x-2">
          <Button
            color="default"
            type="default"
            variant="filled"
            className="mt-4 w-full"
            onClick={handleReject}
          >
            Reject
          </Button>
          <Button
            type="primary"
            className="mt-4 w-full"
            onClick={handleAccept}
            loading={isPending}
          >
            Accept
          </Button>
        </div>
      }
    >
      <div
        dangerouslySetInnerHTML={{
          __html: data?.translations?.en?.content as string,
        }}
        className="terms-content mt-8"
      ></div>
    </ModalWrapper>
  );
}
